export enum DetailsType {
  Gas = 'gas',
  Water = 'water',
  Electricity = 'electricity',
  Warmth = 'warmth',
  Redelivery = 'redelivery',
  Cashback = 'cashback',
}

export enum EnergyType {
  Gas = 'gas',
  Electricity = 'electricity',
  ElectricityAndGas = 'electricityAndGas',
  ElectricityAndTapWater = 'electricityAndTapWater',
  ElectricityAndGasAndWarmth = 'electricityAndGasAndWarmth',
  ElectricityAndGasAndTapWater = 'electricityAndGasAndTapWater',
  ElectricityAndGasAndWarmthAndTapWater = 'electricityAndGasAndWarmthAndTapWater',
  ElectricityAndGasAndWarmthAndTapWaterAndCooling = 'electricityAndGasAndWarmthAndTapWaterAndCooling',
  ElectricityAndWarmth = 'electricityAndWarmth',
  ElectricityAndWarmthAndCooling = 'electricityAndWarmthAndCooling',
  ElectricityAndWarmthAndTapWater = 'electricityAndWarmthAndTapWater',
  ElectricityAndWarmthAndTapWaterAndCooling = 'electricityAndWarmthAndTapWaterAndCooling',
  Warmth = 'warmth',
  WarmthAndCooling = 'warmthAndCooling',
  Cooling = 'cooling',
  WarmthAndTapWater = 'warmthAndTapWater',
  WarmthAndTapWaterAndCooling = 'warmthAndTapWaterAndCooling',
  TapWater = 'tapwater',
  ElectricityAndGeothermalHeating = 'electricityAndGeothermalHeating',
  GeothermalHeating = 'geothermalHeating',
}

export enum BuildingType {
  Apartment = 'apartment',
  TerracedHouse = 'terracedHouse',
  CornerHouse = 'cornerHouse',
  SemiDetachedHouse = 'semiDetachedHouse',
  DetachedHouse = 'detachedHouse',
}

export enum BuildingAgeType {
  Before1945 = 'before1945',
  Between1945And2000 = 'between1945And2000',
  After2000 = 'after2000',
  Unknown = 'unknown',
}

export enum FlowRouteCategory {
  BoilerCheck = 'boilercheck',
  Calculation = 'calculation',
  Contract = 'contract',
  Offer = 'offer',
  Overview = 'overview',
  Installation = 'installation',
  Options = 'options',
  Details = 'details',
  CancelReason = 'cancelreason',
  Summary = 'summary',
  Usage = 'usage',
  Interest = 'interest',
  Appointment = 'appointment',
  SolarPanels = 'solarpanels',
  Suitability = 'suitability',
  LivingProfile = 'livingProfile',
  Welcome = 'welcome',
  Quote = 'quote',
  Result = 'result',
  Login = 'login',
  Installment = 'installment',
  Heating = 'heating',
  Space = 'space',
  Photos = 'photos',
  Choice = 'choice',
  Deceased = 'deceased',
  DeceaseDate = 'deceaseDate',
  keyHandoverDate = 'keyHandoverDate',
  Contact = 'contact',
  Payment = 'payment',
  Boiler = 'boiler',
  BuildingDetails = 'buildingDetails',
  JeGegevens = 'jeGegevens',
  JePostcode = 'jePostcode',
  JeVerbruik = 'jeVerbruik',
  JeWoning = 'jeWoning',
  YourSolarPanels = 'yourSolarPanels',
  YourSmartMeter = 'yourSmartMeter',
  YourData = 'yourData',
  YourPostcode = 'yourPostcode',
  ProductSelection = 'productSelection',
  ThankYou = 'thanks',
}
